<template>
    <div :class="color" class="burn top-0 left-0 z-20 absolute w-full h-full pointer-events-none" aria-hidden="true" :style="style"></div>
</template>

<script>
import { computed } from 'vue';

export default {

    props: {
        direction: {
            default: 'left'
        },
        color: {
            default: 'bg-primary-800'
        },
        start: {
            default: '10%'
        },
        end: {
            default: '70%'
        }
    },
    
    setup(props) {

        const flow = computed(() => {
            const flows = {
                'left': 'to right',
                'right': 'to left',
                'top': 'to bottom',
                'bottom': 'to top'
            }
            return flows[props.direction];
        });

        const style = computed(() => {
            let output = `mask-image: linear-gradient(${flow.value}, rgba(0, 0, 0, 1.0) ${props.start}, transparent ${props.end});`;
            let webkit = '-webkit-' + output;
            return output + webkit;
        });

        return {
            style
        }

    }

}
</script>